module.exports = __webpack_public_path__ + "img/icon-map-next.4fa3ff58.svg";